import { Injectable } from '@angular/core';
import { Router } from '@angular/router';


import { HttpCssClient } from '../shared/http-request.interceptor';

import { Observable } from 'rxjs';

import { LocationSettings } from  '../settings/location.settings';
import { HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AnalyticsUtilsService } from '../shared/analytics-utils.service';
import { map } from 'rxjs/internal/operators/map';

@Injectable()
export class LocationService{
    constructor(private http: HttpCssClient, private router:Router,  private analytics: AnalyticsUtilsService){};

    public findTopLocations(continentId?:number):Observable<any>{
        let url = LocationSettings.TOP_LOCATIONS;
        let params = new HttpParams();
        if(continentId){params.append('continentId',`${continentId}`);}
        return this.http.get(url, params);
    }

    public findAllLocations():Observable<any>{
        let url = LocationSettings.ALL_LOCATIONS;

        return this.http.get(url);
    }

    public searchLocation(query:Object):Observable<any>{
        let url = LocationSettings.SEARCH_LOCATIONS;

        return this.http.post(url,query).pipe(map( results => {
            // Register the search into analytics.
            if (results.body && results ) {
                if (results.body.length == 0) {
                    this.analytics.user_search_with_no_result(query.toString());
                } else {
                    this.analytics.user_search_with_result(query.toString());
                }
            }
            return results;
        }));
    }
}